import React, { useEffect, useRef } from "react";
import { FaTimes } from "react-icons/fa";

import CarteFrance from "./CarteFrance";

function SharedEventsMapModal({
  isOpen,
  events = [],
  onClose,
  onDepartmentSelect,
}) {
  const closeButtonRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;

    closeButtonRef.current?.focus();

    const handleKeyDown = (keyboardEvent) => {
      if (keyboardEvent.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[90] flex items-end justify-center bg-slate-950/70 px-3 backdrop-blur-sm sm:items-center sm:px-4">
      <div className="relative flex max-h-[92vh] w-full max-w-6xl flex-col overflow-hidden rounded-t-[2rem] border border-white/20 bg-white shadow-2xl dark:bg-slate-900 sm:rounded-[2rem]">
        <div className="flex items-start justify-between gap-4 border-b border-slate-200 p-4 dark:border-white/10 sm:p-5">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.16em] text-sky-600 dark:text-sky-200">
              Carte interactive
            </p>

            <h2 className="mt-1 font-titre text-2xl font-bold text-slate-950 dark:text-white">
              Départements avec événements partagés
            </h2>

            <p className="mt-2 text-sm font-medium text-slate-500 dark:text-white/50">
              Clique sur un département en bleu pour appliquer le filtre.
            </p>
          </div>

          <button
            ref={closeButtonRef}
            type="button"
            onClick={onClose}
            className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-slate-100 text-slate-600 transition hover:bg-red-50 hover:text-red-600 focus:outline-none focus:ring-4 focus:ring-slate-200 dark:bg-white/10 dark:text-white dark:hover:bg-red-500/10 dark:hover:text-red-200"
            aria-label="Fermer"
          >
            <FaTimes />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-3 sm:p-5">
          <CarteFrance
            events={events}
            onDepartmentSelect={onDepartmentSelect}
            onClose={onClose}
          />
        </div>
      </div>
    </div>
  );
}

export default SharedEventsMapModal;